<template>
    <div class="container" v-if="items.length">
        <h5 class="font-active head">New & Noteworthy</h5>

        <swiper :modules="[SwiperAutoplay]"
            :autoplay="{
              delay: 25000,
              disableOnInteraction: false
            }"
            :spaceBetween="18"
            :loop="true"
            :loopAdditionalSlides="5"
            :breakpoints="{
              0: {
                slidesPerView:1.6,
                slidesPerGroup:1,
                centeredSlides: true,
                spaceBetween: 0,
                loopedSlides: 1, 
              },  
              512: {
                slidesPerView: 3,
                slidesPerGroup: 1,
                autoplay: {
                  delay: 2500,
                  disableOnInteraction: false
                },
              },
              1150: {
                slidesPerView: 4,
                slidesPerGroup: 1,
                autoplay: {
                  delay: 2500,
                  disableOnInteraction: false
                },
              },
            }" class="mySwiper py-2">
            <swiper-slide v-for="item in items" :key="item.id" class="slideMob" >
                <div class="slide_box" v-if="item">
                    <div class="img_box">
                            <img
                                width="240"
                                height="240"
                                loading="lazy"
                                class="thumb"
                                :src="item?.metals[0]?.images.round"
                                alt="Halo Engagement Rings"
                            />
                    </div>
                    <div class="detail_box mt-3">
                        <p class="mb-0 title">{{item?.product_name}}</p>
                        <p class="price">{{ $formatPrice(item?.metals[0].price) }}</p>
                        
                        <div class="metal_color">
                            <p class="metal_box" v-for="metal in item.metals" :key="metal.id" :class="metal.icon"></p>
                         </div>
                    </div>
                    <div class="banner_btn">
                    <NuxtLink class="anker radious_four" :to="localePath({ name: 'cyo-setting-detail-ring', params : { slug: item?.metals[0]?.slug} })">Create your own
                    </NuxtLink>
                    <NuxtLink class="anker radious_four" :to="localePath({ path: '/preset-engagement-rings/'+item?.metals[0]?.preset_slug })">Shop pre-designed
                    </NuxtLink>
                    </div>
                </div>
            </swiper-slide>
        </swiper>
    </div>
</template>


<script setup>

    const { $formatPrice } = useNuxtApp();
    const localePath = useLocalePath();
    const route = useRoute();
    const items = ref([]);

    const fetchItems = async () => {
    let url = '/config/custom/product?module_type=engagementring'

    try {
        const response = await $fetch(useCountryPath(url));
        items.value = response.data.items;   
        }
        catch (error) {
            console.error('Failed to fetch items:', error);
        } 
    };

    
    onMounted(()=>{
        fetchItems() 
    })

</script>

<style scoped>
h5 {
    font-size: 32px;
    font-weight: 400;
    text-align: center;
}

.head {
    margin-bottom: 15px;
}

.slide_box img {
    transition: 0.5s;
}

.slide_box:hover img {
    /* transform: scale(1.1); */
    transition: 0.5s;
}

.slide_box:hover {
    box-shadow: 0px 0px 12px 0px #00000033;
    border: 1px solid #eaeaea;
    border-radius: 8px;
    overflow: hidden;
}

.slide_box {
    padding: 16px;
}

.img_box {
    text-align: center
}

.banner_btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px 0;
    margin-top: 12px;
}

.banner_btn a {
    padding: 12px 20px;
    font-size: 14px;
    min-width: 210px;
    max-width: 210px;
    text-align: center;
    color: #353535;
    letter-spacing: 1.5px;
    font-weight: 700;
    text-transform: uppercase;
    border: 1.5px solid #353535;
}

.ctas:hover {
    display: block;
}

.metals {
    display: flex;
    margin-bottom: 10px;
    justify-content: center;
}

.detail_box {
    text-align: center;
}

.title {
    font-size: 16px;
    font-weight: 500;
    min-height: 50px;
}

.price {
    color: #668B84;
    font-size: 16px;
    font-weight: 700;
    text-align: center;
}

.metal_color .metal_box {
    height: 20px;
    width: 20px;
    /* margin-right: 5px; */
    cursor: pointer;
    /* border: 2px solid #fff; */
    border-radius: 2px;
}


.metal_color .metal_box.active {
    height: 22px;
    width: 22px;
    border: 1px solid #606060;
}

.metal_color {
    gap: 8px;
}

.metal_color p {
    display: inline-block;
    margin-right: 8px
}

.yellow {
    background: #f3dda1;
}

.rose {
    background: #f3b089;
}

.white,
.platinum {
    background: #eff0f0;
}

/* Initially hide the CTA buttons and position them below */
/* display: none; */
.banner_btn {
    opacity: 0;
    transform: translateY(20px);
    transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
}

.slide_box:hover .banner_btn {
    opacity: 1;
    transform: translateY(0);
}

@media (max-width:767px) {
    .slide_box:hover {
        box-shadow: none;
        border: 0;
    }

    h5 {
        font-size: 24px;
        font-weight: 400;
    }

    .title {
        font-size: 14px;
        font-weight: 500;
    }

    .price {
        font-size: 16px;
        font-weight: 700;
    }

    .banner_btn {
        opacity: 1;
        transform: translateY(0);
    }

    .slide_box:hover .banner_btn {
        opacity: 1;
    }

    :global(.swiper-slide.slideMob .banner_btn) {
        display: none;
    }

    :global(.swiper-slide-active.slideMob .banner_btn) {
        display: flex;
    }
}
</style>